// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {alertService} from '../../../services/AlertService';

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {
    getKelompokKegiatan,
    insertKelompokKegiatan,
    kelompokKegiatanSelector,
    updateKelompokKegiatan
} from './kelompokKegiatanSlice';


import {Colors} from "../../../assets/Colors";

const KelompokKegiatanPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const kelompokKegiatan = useSelector(
        kelompokKegiatanSelector
    );


    useEffect(() => {
        dispatch(getKelompokKegiatan({
            start: start,
            count: count,
            search: '',
        }));

    }, []);

    useEffect(() => {

        if ((search !== '') && kelompokKegiatan.isGetSuccess && !kelompokKegiatan.isGetFetching) {
            let calc = kelompokKegiatan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kelompokKegiatan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && kelompokKegiatan.isGetSuccess && !kelompokKegiatan.isGetFetching) {
            let calc = kelompokKegiatan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kelompokKegiatan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!kelompokKegiatan?.isGetFetching && kelompokKegiatan.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = kelompokKegiatan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kelompokKegiatan.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getKelompokKegiatan({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (kelompokKegiatan.isGetSuccess) {
                alertService.success(kelompokKegiatan.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getKelompokKegiatan({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (kelompokKegiatan.isUpdateSuccess) {
                alertService.success(kelompokKegiatan.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateKelompokKegiatan({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetKelompokKegiatan(params) {
    //   return dispatch(getKelompokKegiatan(params));
    // }

    function handleInsertKelompokKegiatan(param) {
        setInsertFetch(true);
        const params = {
            NamaKelompokKegiatan: param.inputOneValue,
        };

        dispatch(insertKelompokKegiatan(params));
    }

    function handleUpdateKelompokKegiatan(param) {
        setUpdateFetch(true);

        const params = {
            NamaKelompokKegiatan: param.inputOneValue,
            KelompokKegiatanID: currentData.KelompokKegiatanID,
            status: param.status,
        };
        dispatch(updateKelompokKegiatan(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getKelompokKegiatan(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getKelompokKegiatan(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (kelompokKegiatan.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? kelompokKegiatan.count : newCount,
            search: search,
        }
        dispatch(getKelompokKegiatan(params));

        setPage(1);
        setCount((newCount === "-1") ? kelompokKegiatan.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>
    } else {
        return (

            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                handleSearch={handleSearch}
                                searchPlaceholder="Kelompok Kegiatan"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Kelompok Kegiatan"
                                tableData={kelompokKegiatan.data}
                                colOneTitle="ID"
                                colOneData="KelompokKegiatanID"
                                colTwoTitle="Nama Kelompok Kegiatan"
                                colTwoData="NamaKelompokKegiatan"
                                status="Status"

                                fetching={kelompokKegiatan.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}

                            />
                        </div>
                    </div>
                </div>
                {showModalAdd &&
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Kelompok Kegiatan"
                        inputOneTitle="Nama Kelompok Kegiatan"
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertKelompokKegiatan}
                    />
                }
                {showModalEdit &&
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.KelompokKegiatanID}
                        modal={handleModal}
                        modalTitle="Ubah Kelompok Kegiatan"
                        inputOneTitle="Nama Kelompok Kegiatan"
                        inputOneValue={currentData.NamaKelompokKegiatan}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateKelompokKegiatan}
                    />
                }
            </div>

        )
    }

}


export default KelompokKegiatanPage;